import { render, staticRenderFns } from "./PhoneVerificationNote.vue?vue&type=template&id=3cf71c9c&scoped=true"
import script from "./PhoneVerificationNote.vue?vue&type=script&lang=js"
export * from "./PhoneVerificationNote.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerificationNote.vue?vue&type=style&index=0&id=3cf71c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf71c9c",
  null
  
)

export default component.exports